import React, { useEffect, useMemo, useState } from "react";
import classNames from "classnames";
import CarExteriorViewer from "../../sections/car-exterior-viewer";
import CarInteriorViewer from "../../sections/car-interior-viewer";
import "./style.scss";
const Car360View = props => {
  const { fields } = props;
  const { models, exteriorSwitcherText, interiorSwitcherText } = fields;
  const [modelIndex, setModelIndex] = useState(0);
  const currentColor = useMemo(() => models[modelIndex].fields.color, [modelIndex]);
  const currentModelType = useMemo(() => models[modelIndex].fields.modelType, [modelIndex]);
  const [showExterior, setShowExterior] = useState(true);
  const onModelChange = (e, index) => {
    setModelIndex(index);
  };
  return (
    <div className="c-car360-view">
      <div className="c-car360-view__toolbar">
        <div className="c-car360-view__switcher">
          <div className={classNames("c-car360-view__switcher-item", { active: showExterior })} onClick={e => setShowExterior(true)}>
            {exteriorSwitcherText.value}
          </div>
          <div className="c-car360-view__switcher-line" />
          <div className={classNames("c-car360-view__switcher-item", { active: !showExterior })} onClick={e => setShowExterior(false)}>
            {interiorSwitcherText.value}
          </div>
        </div>
        <div className="c-car360-view__current-color">
          {currentModelType.fields.text.value} {currentColor.fields.text.value}
        </div>
      </div>
      <div className="c-car360-view__main">
        {showExterior && <CarExteriorViewer {...{ fields, modelIndex, onModelChange }} />}
        {!showExterior && <CarInteriorViewer {...{ models, modelIndex, onModelChange }} />}
      </div>
    </div>
  );
};
export default Car360View;
